// extracted by mini-css-extract-plugin
module.exports = {"bgGreenKv":"FriendsOnlySpecialSet_bgGreenKv__RY2N6","bgInvited":"FriendsOnlySpecialSet_bgInvited__RmvX9","icon":"FriendsOnlySpecialSet_icon__CalXq"};